import { For } from 'solid-js'

function hashSeed(input: string): number {
	let h = 0
	for (let i = 0; i < input.length; i++) {
		h = (Math.imul(31, h) + input.charCodeAt(i)) | 0
	}
	return h >>> 0
}

function mulberry32(a: number) {
	return () => {
		a |= 0
		a = (a + 0x6d2b79f5) | 0
		let t = Math.imul(a ^ (a >>> 15), 1 | a)
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296
	}
}

const W = 172
const H = 96

export default function Cover(props: { seed: string; color: string }) {
	const seedNum = hashSeed(props.seed)
	const rand = mulberry32(seedNum)
	const blobs = Array.from({ length: 4 }, () => ({
		cx: rand() * W,
		cy: rand() * H,
		r: 16 + rand() * 34,
		o: 0.05 + rand() * 0.07,
	}))
	const gradId = `go-read-cover-${seedNum}`

	return (
		<svg
			viewBox={`0 0 ${W} ${H}`}
			preserveAspectRatio="xMidYMid slice"
			width="100%"
			height="100%"
			style={{ display: 'block' }}
			aria-hidden="true"
		>
			<defs>
				<linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
					<stop offset="0" stop-color={props.color} />
					<stop offset="1" stop-color={props.color} stop-opacity="0.55" />
				</linearGradient>
			</defs>
			<rect width={W} height={H} fill={`url(#${gradId})`} />
			<rect width={W} height={H} fill="#0d1117" fill-opacity="0.24" />
			<For each={blobs}>
				{(b) => <circle cx={b.cx} cy={b.cy} r={b.r} fill="#ffffff" fill-opacity={b.o} />}
			</For>
			<rect x="15" y="16" width={W * 0.46} height="6" rx="3" fill="#ffffff" fill-opacity="0.92" />
			<For each={[0, 1, 2]}>
				{(i) => (
					<rect
						x="15"
						y={30 + i * 8}
						width={W * (0.58 - i * 0.09)}
						height="4"
						rx="2"
						fill="#ffffff"
						fill-opacity={0.42 - i * 0.08}
					/>
				)}
			</For>
		</svg>
	)
}
